import request from 'config/axios'

const URL = '/transfer-financial/financial/accounts'
const SEND_TRANSFER_URL = '/transfer-financial/financial'

export const getTransferAccounts = () => request.get(URL) // eslint-disable-line
export const sendTransfer = (payload) => request.post(SEND_TRANSFER_URL, payload) // eslint-disable-line
